import React from "react";
import {
    Dashboard
} from "../../_metronic/_partials";
import Table from "../components/Ui/Table";
import axios from 'axios';
import GenericModal from "../components/Modals/GenericModal";
import {DELETE_FICHE, DOWNLOAD_FICHE_RESUME, EXPORT_EXCELL, SEARCH_FICHES} from "../api/Api";
import {useSelector} from "react-redux";
import * as moment from "moment";
import StateView from "../components/Ui/StateView";
import {useFormik} from "formik";
import CircularProgress from "@material-ui/core/CircularProgress";
import BootstrapLoadingButton from "../components/Ui/BootstrapLoadingButton";
import fileDownload from "js-file-download";
import {useHistory, NavLink, Link} from 'react-router-dom'
import {FICHE_STATES} from "../utils/constants";
import {OverlayTrigger} from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import ConfirmationModal from "../components/Modals/ConfirmationModal";
import Dropdown from "../components/Ui/Dropdown";


export function DashboardPage() {

    const history = useHistory();

    const [ficheUnderModification, setFicheUnderModification] = React.useState();
    const [formValues, setFormValues] = React.useState({});
    const {user} = useSelector(state => state.auth);

    const [isSearching, setIsSearching] = React.useState(false);
    const [isExporting, setIsExporting] = React.useState(false);
    const [isDeleting, setIsDeleting] = React.useState(false);

    const tableRef = React.useRef(null);
    const formik = useFormik({
        initialValues: {
            code: '',
            description_travaux: ''
        },
        onSubmit(values) {
            if (tableRef.current)
                tableRef.current.searchFiches(values)
            setFormValues(values)
        }
    });

    async function downloadFicheResume(fiche) {

        try {

            setIsExporting(true);

            const response = (await axios.get(
                `${DOWNLOAD_FICHE_RESUME}/${fiche.id}`,
                {
                    responseType: 'blob'
                }
            ));

            fileDownload(response.data, `PGT_${fiche.code}.pdf`);
        } catch (e) {
            console.log(e);
        } finally {
            setIsExporting(false);
        }


    }

    async function exportExcel() {

        try {

            setIsExporting(true);

            const response = (await axios.get(
                EXPORT_EXCELL,
                {
                    responseType: 'blob',
                    params: {
                        ...formValues
                    }
                }
            ));

            fileDownload(response.data, `PGT_${moment().format('DD_MM_YYYY_hh_mm')}.xlsx`);
        } catch (e) {
            console.log(e);
        } finally {
            setIsExporting(false);
        }


    }

    async function deleteFiche(fiche) {

        try {

            setIsDeleting(true);

            const response = (await axios.delete(
                `${DELETE_FICHE}/${fiche.id}`,
            ));

            tableRef.current.searchFiches({})

        } catch (e) {
            console.log(e);
        } finally {
            setIsDeleting(false);
        }


    }

    return (
        <div>
            <div
                style={{
                    height: 'auto',
                    backgroundImage: 'url("/images/PGT_PATTERN.svg")',
                    backgroundColor: 'white',
                    backgroundSize: '27%'
                }}
                id="kt_subheader" className="subheader py-5 py-lg-10 gutter-b subheader-transparent">
                <div className="container d-flex flex-column">
                    <div className="d-flex align-items-md-center mb-2 flex-column flex-md-row">


                        <div className={'mr-5'}>
                            <NavLink className="btn btn-light-success" to="/fiches/create">
                                <span className="">Soumettre une nouvelle demande</span>
                            </NavLink>
                        </div>

                        <div className="bg-white rounded p-4 d-flex flex-grow-1 flex-sm-grow-0">
                            <form
                                onSubmit={formik.handleSubmit}
                                className="form d-flex align-items-md-center flex-sm-row flex-column flex-grow-1 flex-sm-grow-0">
                                <div className="d-flex align-items-center py-3 py-sm-0 px-sm-3">
												<span className="svg-icon svg-icon-lg">
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                         width="24px"
                                                         height="24px" viewBox="0 0 24 24" version="1.1">
														<g stroke="none" stroke-width="1" fill="none"
                                                           fill-rule="evenodd">
															<rect x="0" y="0" width="24" height="24"></rect>
															<path
                                                                d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                                                fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
															<path
                                                                d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                                                fill="#000000" fill-rule="nonzero"></path>
														</g>
													</svg>
												</span>
                                    <input type="text"
                                           value={formik.values.code} onChange={(e) => {
                                        formik.setFieldValue('code', e.target.value)
                                    }}
                                           className="form-control border-0 font-weight-bold pl-2"
                                           placeholder="Numéro de la demande"/>
                                </div>
                                <span className="bullet bullet-ver h-25px d-none d-sm-flex mr-2"></span>
                                <div className="d-flex align-items-center py-3 py-sm-0 px-sm-3">
												<span className="svg-icon svg-icon-lg">
                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                         width="24px"
                                                         height="24px" viewBox="0 0 24 24" version="1.1">
														<g stroke="none" stroke-width="1" fill="none"
                                                           fill-rule="evenodd">
															<rect x="0" y="0" width="24" height="24"></rect>
															<rect fill="#000000" x="4" y="4" width="7" height="7"
                                                                  rx="1.5"></rect>
															<path
                                                                d="M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z"
                                                                fill="#000000" opacity="0.3"></path>
														</g>
													</svg>
												</span>

                                    <input type="text"
                                           value={formik.values.description_travaux} onChange={(e) => {
                                        formik.setFieldValue('description_travaux', e.target.value)
                                    }}
                                           className="form-control border-0 font-weight-bold pl-2"
                                           placeholder="Description des travaux"/>

                                </div>
                                <button type="submit"
                                        className="btn btn-light-primary d-flex align-items-center font-weight-bold btn-hover-light-primary mt-3 mt-sm-0 px-7">
                                    <span className="d-inline-block mr-3">Rechercher</span>
                                    {
                                        isSearching && (
                                            <CircularProgress thickness={9} size={20} disableShrink color={'white'}/>
                                        )
                                    }
                                </button>
                            </form>
                        </div>
                        {/*<div className="mt-4 my-md-0 mx-md-10">*/}
                        {/*    <a href="#" className="text-white font-weight-bolder text-hover-primary">Advanced Search</a>*/}
                        {/*</div>*/}

                    </div>
                </div>
            </div>

            <div style={{marginTop: 125}}>


                <Table
                    onSearchStateChangeCallback={setIsSearching}
                    ref={tableRef}
                    title={'Mes demandes'}
                    renderToolbar={() => {
                        return (
                            <>
                                <div onClick={exportExcel} className="btn btn-light-primary">
                                    Exporter la liste en fichier Excel
                                </div>
                            </>
                        )
                    }}
                    assets={{
                        typeTravaux: {
                            isLoading: false,
                            items: [{
                                id: 1,
                                label: 'Electriques'
                            },
                                {
                                    id: 2,
                                    label: 'Eau potable'
                                },
                                {
                                    id: 3,
                                    label: 'Electrique & Eau potable'
                                }
                            ]
                        }
                    }}

                    columns={[
                        {
                            label: 'Numéro',
                            itemKey: 'code'
                        },
                        {
                            label: 'type',
                            render(item, assets) {

                                if (item.type_travaux == 1) {
                                    return (
                                        <span className='text-primary font-weight-bold'>Électrique</span>
                                    );
                                }

                                if (item.type_travaux == 2) {
                                    return (
                                        <span className='text-success font-weight-bold'>Eau potable</span>
                                    );
                                }

                                if (item.type_travaux == 3) {
                                    return (
                                        <>
                                            <span className='text-primary font-weight-bold'>Électrique </span>
                                            et
                                            <span className='text-success font-weight-bold'> Eau potable</span>
                                        </>
                                    );
                                }

                                return assets.typeTravaux.items.find(type => type.id == item.type_travaux)?.label || '-'
                            }
                        },
                        {
                            label: 'Nature',
                            render(item, assets) {

                                const text = item.nature_travaux_data.map(
                                    item => item.libelle
                                ).join(', ');

                                if (text.length > 25)
                                    return (
                                        <OverlayTrigger
                                            placement="bottom"
                                            overlay={
                                                <Tooltip id="latest-project">{text}</Tooltip>
                                            }
                                        >
                                            <span>
                                                {text.substring(0, 25)}...
                                            </span>
                                        </OverlayTrigger>
                                    )

                                return (
                                    <span>
                                        {text}
                                    </span>
                                )

                            }
                        },
                        {
                            label: 'Description',
                            itemKey: 'description_travaux'
                        },
                        /*{
                            label: 'Nom & Prenoms / Raison sociale',
                            render(item) {
                                return `${item.raison_sociale || ''}${item.nom || ''} ${item.prenoms || ''}`
                            }
                        },*/
                        {
                            label: 'Contacts',
                            render(item) {
                                return [item.mobile, item.mobile_2].filter(item => !!item).join(', ')
                            }
                        },
                        /*{
                            label: 'Email',
                            itemKey: 'email'
                        },*/
                        {
                            label: 'Statut',
                            order: 'type_travaux',
                            render(item) {
                                return (
                                    <div>


                                        {
                                            [1, 3].includes(item.type_travaux) && (
                                                <div className="">

                                                    <div className={'small font-weight-bold text-primary'}>
                                                        CIE
                                                    </div>
                                                    <StateView activeState={item.state} states={FICHE_STATES}/>

                                                </div>
                                            )
                                        }

                                        {
                                            [2, 3].includes(item.type_travaux) && (

                                                <div className="">

                                                    <div className={'small font-weight-bold text-success'}>
                                                        SODECI
                                                    </div>
                                                    <StateView activeState={item.state_sodeci} states={FICHE_STATES}/>

                                                </div>

                                            )
                                        }

                                    </div>
                                )
                            }
                        },
                        {
                            label: 'Date d\'initiation',
                            order: 'date_initiation',
                            render(item) {
                                if (item.date_initiation_cie || item.date_initiation_sodeci) {
                                    const time = moment(item.date_initiation_cie || item.date_initiation_sodeci);

                                    return (
                                        <div className="">
                                            <div>{time.format('DD/MM/Y')}</div>
                                            {time.format('HH:mm')}
                                        </div>
                                    )

                                }
                            }
                        },
                        {
                            label: 'Dernière mise à jour',
                            render(item) {
                                return (
                                    <div className={''}>
                                        <div>{moment(item.updated_at).format('DD/MM/Y')}</div>
                                        <div>{moment(item.updated_at).format('HH:mm')}</div>
                                    </div>
                                )
                            }
                        }
                    ]}

                    actions={[
                        /*{
                            render(){
                                return (
                                    <span className={'btn btn-icon btn-light-danger'}>
                                    <i className={'flaticon2-delete'}></i>
                                </span>
                                )
                            },
                            shouldDisplay(item) {
                                return true;
                            },
                            getHttpAction(item) {
                                return {
                                    axiosInstance: function () {
                                        return axios.get('http://google.fr');
                                    },
                                    onSuccess(item, responseData) {

                                    },
                                    onError(item) {

                                    },
                                };
                            }
                        },*/
                        //{
                        //    icon: 'flaticon2-edit',
                        //    onClick(item) {
                        //        setFicheUnderModification(item)
                        //    }
                        //},
                        {

                            shouldDisplay(item) {
                                return true
                            },
                            render(item) {
                                return (
                                    <Dropdown
                                        activator={() => (
                                            <div className={'btn btn-primary'}>ACTIONS</div>
                                        )}
                                    >

                                        <div>
                                            {

                                                (item.state || item.state_sodeci) && (

                                                    <div onClick={() => {
                                                        history.push(`/fiches/details/${item.id}/recapitulatif`);
                                                    }}
                                                                   className={'btn btn-light-primary d-flex justify-content-between align-items-center'}
                                                                   eventKey="1">
                                                        <i className="flaticon2-list-1"></i>
                                                        <div className={''}>
                                                            <span className="font-weight-bold">Voir</span>
                                                        </div>

                                                    </div>
                                                )

                                            }


                                            {

                                                (item.state || item.state_sodeci) && (

                                                    <BootstrapLoadingButton isLoading={isExporting} onClick={() => {
                                                        downloadFicheResume(item)
                                                    }}
                                                                            className={'btn btn-light-success w-100 d-flex justify-content-between align-items-center'}>
                                                        <i className={'flaticon2-download'}></i>
                                                        Téléch.
                                                    </BootstrapLoadingButton>
                                                )

                                            }

                                            {

                                                (!item.state && !item.state_sodeci) && (
                                                    <div onClick={() => {
                                                        history.push(`/fiches/create?formCode=${item.form_code}&step=0`);
                                                    }}
                                                                   className={'btn btn-light-primary d-flex justify-content-between align-items-center'}
                                                                   eventKey="1">
                                                        <span className={'flaticon-edit'}></span>
                                                        <div className={''}>
                                                            <span className="font-weight-bold">Modifier</span>
                                                        </div>
                                                    </div>
                                                )

                                            }

                                            {

                                                (item.state == 'App\\Models\\Fiches\\States\\WaitingUserConfirmationStep') && (
                                                    <div onClick={() => {
                                                        history.push(`/fiches/recapitulatif/${item.code}`);
                                                    }}
                                                                   className={'btn small btn-light-info d-flex justify-content-between align-items-center'}
                                                                   eventKey="1">
                                                        <span className={'flaticon-list-2'}></span>
                                                        <div className={''}>
                                                            <span className="font-weight-bold">récapitulatif</span>
                                                        </div>
                                                    </div>
                                                )

                                            }


                                            {

                                                (!item.state && !item.state_sodeci) && (

                                                    <ConfirmationModal
                                                        style={{width: '100%'}}
                                                        title={'Confirmation'}
                                                        text={'Cette action est irréversible, êtes vous sûr(e) de vouloir continuer ?'}
                                                        onConfirm={() => {
                                                            deleteFiche(item)
                                                        }}>

                                                        <BootstrapLoadingButton isLoading={isDeleting}
                                                                                className={'btn btn-light-danger w-100 d-flex justify-content-between align-items-center'}>
                                                            Supprimer
                                                            <i className={'flaticon2-delete'} style={{fontSize: 9}}></i>
                                                        </BootstrapLoadingButton>

                                                    </ConfirmationModal>

                                                )

                                            }
                                        </div>

                                    </Dropdown>
                                )
                            }
                        },
                        // {
                        //
                        //     shouldDisplay(item){
                        //         return false
                        //     },
                        //     render(item) {
                        //         return (
                        //         <Dropdown>
                        //             <Dropdown.Toggle id="dropdown-custom-1">Actions</Dropdown.Toggle>
                        //             <Dropdown.Menu className="super-colors">
                        //
                        //                 {
                        //
                        //                     (item.state || item.state_sodeci) && (
                        //
                        //                         <Dropdown.Item onClick={()=>{
                        //                             history.push(`/fiches/details/${item.id}/recapitulatif`);
                        //                         }} className={'btn btn-light-primary d-flex justify-content-between align-items-center'} eventKey="1">
                        //                                         <div className={''}>
                        //                                             <span className="font-weight-bold">Voir</span>
                        //                                         </div>
                        //                                         <i className="flaticon2-list-1"></i>
                        //
                        //                                     </Dropdown.Item>
                        //                     )
                        //
                        //                 }
                        //
                        //
                        //                 {
                        //
                        //                     (item.state || item.state_sodeci) && (
                        //
                        //                         <BootstrapLoadingButton isLoading={isExporting} onClick={()=>{
                        //                             downloadFicheResume(item)
                        //                         }} className={'btn btn-light-success w-100 d-flex justify-content-between align-items-center'}>
                        //                             Téléch.
                        //                         <i className={'flaticon2-download'}></i>
                        //                         </BootstrapLoadingButton>
                        //                     )
                        //
                        //                 }
                        //
                        //                 {
                        //
                        //                     (!item.state && !item.state_sodeci) && (
                        //                         <Dropdown.Item onClick={()=>{
                        //                             history.push(`/fiches/create?formCode=${item.form_code}&step=0`);
                        //                         }} className={'btn btn-light-primary d-flex justify-content-between align-items-center'} eventKey="1">
                        //                                         <div className={''}>
                        //                                             <span className="font-weight-bold">Modifier</span>
                        //                                         </div>
                        //                                         <span className={'flaticon-edit'}></span>
                        //                         </Dropdown.Item>
                        //                     )
                        //
                        //                 }
                        //
                        //                 {
                        //
                        //                     (item.state == 'App\\Models\\Fiches\\States\\WaitingUserConfirmationStep') && (
                        //                         <Dropdown.Item onClick={()=>{
                        //                             history.push(`/fiches/recapitulatif/${item.code}`);
                        //                         }} className={'btn small btn-light-info d-flex justify-content-between align-items-center'} eventKey="1">
                        //                                         <div className={''}>
                        //                                             <span className="font-weight-bold">récapitulatif</span>
                        //                                         </div>
                        //                                         <span className={'flaticon-list-2'}></span>
                        //                         </Dropdown.Item>
                        //                     )
                        //
                        //                 }
                        //
                        //
                        //                 {
                        //
                        //                     (!item.state && !item.state_sodeci) && (
                        //
                        //                         <ConfirmationModal
                        //                             title={'Confirmation'}
                        //                             text={'Cette action est irréversible, êtes vous sûr(e) de vouloir continuer ?'}
                        //                         onConfirm={()=>{deleteFiche(item)}}>
                        //
                        //                             <BootstrapLoadingButton isLoading={isDeleting} className={'btn btn-light-danger w-100 d-flex justify-content-between align-items-center'}>
                        //                                 Supprimer
                        //                                 <i className={'flaticon2-delete'}></i>
                        //                             </BootstrapLoadingButton>
                        //
                        //                         </ConfirmationModal>
                        //
                        //                     )
                        //
                        //                 }
                        //
                        //
                        //             </Dropdown.Menu>
                        //         </Dropdown>
                        //         )
                        //     }
                        // },
                    ]}

                    dataProvider={{

                        async getPageItems(page, filters) {

                            const response = await axios.get(
                                SEARCH_FICHES, {
                                    params: {
                                        page,
                                        ...filters
                                    }
                                }
                            );

                            const {count, currentPage, totalPages, datas} = response.data;

                            return {
                                currentPage,
                                totalPages,
                                count,
                                datas: datas.map(
                                    fiche => {

                                        const foundedTime = fiche.state_histories.filter(
                                            state => state.new_state == 'App\\Models\\Fiches\\States\\FicheTransmittedStep'
                                        )[0]?.created_at;

                                        return {
                                            ...fiche,
                                            transmition_date: foundedTime ? moment(foundedTime).format('D/MM/Y k:m:s') : undefined
                                        }
                                    })
                            }
                        }

                    }}

                />
            </div>


            {
                ficheUnderModification && (
                    <GenericModal
                        isOpen={true}
                        onNegative={setFicheUnderModification}
                    >
                        modal de modification hypothétique d'une fiche
                    </GenericModal>
                )
            }

        </div>
    )
}
